import React, { ImgHTMLAttributes } from 'react'

interface IProps extends ImgHTMLAttributes<any> {
  fallback?: string
}

const ImageComponent: React.FC<IProps> = ({ fallback, src, ...props }) => {
  return <img src={src || fallback} {...props} />
}
export default ImageComponent
